import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, useTheme } from "@mui/material";
import InventoryComponent from "../../component/dashboard-components/Inventory";
import OptInForm from "../../component/OptInForm";
import MapTab from "../../component/dashboard-components/map-components/Map";
import LogTab from "../../component/dashboard-components/Log";
import AnalyticTab from "../../component/dashboard-components/Analytic";
import Overpressure from "../../component/dashboard-components/Overpessure";
import { observer } from "mobx-react-lite";
// import UnifiedMetricsCard from "../../component/dashboard-components/NewMetricCards";
import MetricsDashboard from "../../component/dashboard-components/MetricsManagement";

const DashboardPage = () => {
  const theme = useTheme();
  const location = useLocation();
  const message = location.state?.message || "";
  const [activeTab, setActiveTab] = useState("Inventory");
  const [showOptInForm, setShowOptInForm] = useState(false);

  useEffect(() => {
    if (message.toLowerCase().includes("first time logging in")) {
      setShowOptInForm(true);
    }
  }, [message]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Inventory":
        return (
          <>
            <Box sx={{ mt: 2, mb: 6 }}>
              <MetricsDashboard />
            </Box>
            <InventoryComponent />
          </>
        );
      case "Map":
        return <MapTab />;
      case "Logs":
        return <LogTab />;
      case "Analytics":
        return <AnalyticTab />;
      case "Overpressure":
        return <Overpressure />;
      default:
        return null;
    }
  };

  const handleOptInSubmit = (phone) => {
    console.log("User opted in with phone:", phone);
    alert(`Phone number submitted: ${phone}`);
    setShowOptInForm(false);
  };

  return (
    <>
      {showOptInForm && (
        <>
          <Box
            className="fixed inset-0 bg-black opacity-50 z-10"
            onClick={() => setShowOptInForm(false)}
          />
          <Box className="fixed inset-0 flex items-center justify-center z-20">
            <OptInForm
              onSubmit={handleOptInSubmit}
              onCancel={() => setShowOptInForm(false)}
            />
          </Box>
        </>
      )}

      {/* Tab Buttons */}
      <Box className="flex gap-2 mb-2">
        {["Inventory", "Map", "Logs", "Analytics", "Overpressure"].map(
          (tab) => (
            <Box
              key={tab}
              sx={{
                borderBottom: "2px solid",
                borderColor:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#22C55E"
                    : "transparent",
              }}
            >
              <Button
                onClick={() => setActiveTab(tab)}
                sx={{
                  textTransform: "none",
                  color:
                    activeTab === tab
                      ? theme.palette.mode === "dark"
                        ? theme.palette.primary.main
                        : "#000000"
                      : "text.primary",
                }}
              >
                {tab}
              </Button>
            </Box>
          )
        )}
      </Box>

      {renderActiveTab()}
    </>
  );
};

export default observer(DashboardPage);
